import jssVariables from "../../jss_setup";

export const searchStripActivities = {
  searchStripContent: {
    background: jssVariables.colors.base_color,
    smallscreen: {
      background: jssVariables.colors.base_color,
    },
  },
  loadingIcon: {
    color: jssVariables.colors.secondary_color,
  },
  loaderText: {
    color: jssVariables.colors.secondary_color,
  },
  icon: {
    color: jssVariables.colors.secondary_color,
  },
  btns: {
    background: jssVariables.colors.base_color,
  },
};

export const activityStyles = {
  priceTxt: {
    color: jssVariables.colors.secondary_color,
  },
  priceValue: {
    color: jssVariables.colors.secondary_color,
  },
};

export const actRating = {
  iconFilled: {
    color: jssVariables.colors.secondary_color,
  },
  iconEmpty: {
    color: jssVariables.colors.secondary_color,
  },
  priceComponent: {
    color: jssVariables.colors.secondary_color,
  },
};
